import { ContentTag, currentPage, provideComponent } from "scrivito"

import { TitleWidget } from "./TitleWidgetClass"
import "./styles/_title-widget.scss"

provideComponent(TitleWidget, ({ widget }) => {
  const page = currentPage()
  const tag = widget.get("tag") || "h1"

  return (
    <ContentTag
      content={page}
      attribute="title"
      tag={tag}
      className="title-widget"
    />
  )
})
